/** MUI spacing units aligned with theme tokens (e.g. --space-2-5 → 10px). */
export const PANEL_GAP = 2.5;
